import { render, staticRenderFns } from "./FormThuxHorizontalSelect.vue?vue&type=template&id=b8347f24&"
import script from "./FormThuxHorizontalSelect.vue?vue&type=script&lang=js&"
export * from "./FormThuxHorizontalSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports